import { Route, Routes } from "react-router-dom";

// File Imports --
import PageNotFound from "../404/404Error";
import Dashboard from "../home/Dashboard";
import "../../App.css";
import FilesManager from "../images/FilesManager";
import PagesTable from "../pages/PagesTable";
import PagesAdd from "../pages/PagesAdd";
import PagesUpdate from "../pages/PagesUpdate";
import SliderTable from "../slider/SliderTable";
import SliderAdd from "../slider/SliderAdd";
import SliderUpdate from "../slider/SliderUpdate";
import UserTable from "../user/UserTable";
import UserAdd from "../user/UserAdd";
import UserUpdate from "../user/UserUpdate";
import Setting from "../setting/Setting";
import TeamTable from "../team/TeamTable";
import TeamAdd from "../team/TeamAdd";
import TeamUpdate from "../team/TeamUpdate";
import TestimonialTable from "../testimonial/TestimonialTable";
import TestimonialAdd from "../testimonial/TestimonialAdd";
import TestimonialUpdate from "../testimonial/TestimonialUpdate";
import ContactTable from "../contact/ContactTable";
import BlogTable from "../blog/BlogTable";
import BlogAdd from "../blog/BlogAdd";
import BlogUpdate from "../blog/BlogUpdate";
import ProfileUpdate from "../profile/ProfileUpdate";
import SeoTable from "../seo/SeoTable";
import SeoAdd from "../seo/SeoAdd";
import SeoUpdate from "../seo/SeoUpdate";
import DBManager from "../db/DBManager";
import GalleryTable from "../gallery/GalleryTable";
import GalleryAdd from "../gallery/GalleryAdd";
import GalleryUpdate from "../gallery/GalleryUpdate";
import NewsLetterTable from "../newsletter/NewsLetterTable";
import CareerTable from "../careers/CareerTable";
import CareerAdd from "../careers/CareerAdd";
import CareerUpdate from "../careers/CareerUpdate";
import CareersQueryTable from "../careersQuery/CareersQueryTable";
import LeadTable from "../lead/LeadTable";
import LeadAdd from "../lead/LeadAdd";
import LeadUpdate from "../lead/LeadUpdate";
import DiscountCouponTable from "../master/DiscountCouponTable";
import DiscountCouponForm from "../master/DiscountCouponForm";
import SubscriptionPlanTable from "../master/SubscriptionPlanTable";
import SubscriptionPlanForm from "../master/SubscriptionPlanForm";
import FacilityTable from "../facility/FacilityTable";
import FacilityAdd from "../facility/FacilityAdd";
import FacilityUpdate from "../facility/FacilityUpdate";
import VendorTable from "../vendor/VendorTabel";
import ManageVendor from "../vendor/ManageVendor";
import ViewVendor from "../vendor/ViewVendor";
import VendorBills from "../vendor/widgets/VendorBills";
import WebhookLogs from "../log/WebhookLogs";
import VendorBillLogs from "../log/VendorBillLogs";
import AdminDiscountDashboard from "../vendor/AdminDiscountDashboard";
import UpcomingBillingDates from "../vendor/UpcomingBillingDates";
import VendorPurge from "../vendor/VendorPurge";
import DiscountLogs from "../log/DiscountLogs";

const RoutesList = ({ ProtectedRoute }) => {
  return (
    <Routes>
      {/* Authenticated Routes */}
      <Route
        path="*"
        element={
          <ProtectedRoute>
            <PageNotFound />
          </ProtectedRoute>
        }
      />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      {/* Other routes wrapped in ProtectedRoute */}
      <Route
        path="/file-manager"
        element={
          <ProtectedRoute>
            <FilesManager />
          </ProtectedRoute>
        }
      />
      <Route
        path="/pages-seo"
        element={
          <ProtectedRoute>
            <SeoTable />
          </ProtectedRoute>
        }
      />
      <Route
        path="/pages-seo/add"
        element={
          <ProtectedRoute>
            <SeoAdd />
          </ProtectedRoute>
        }
      />
      <Route
        path="/pages-seo/edit/:id"
        element={
          <ProtectedRoute>
            <SeoUpdate />
          </ProtectedRoute>
        }
      />
      <Route
        path="/team"
        element={
          <ProtectedRoute>
            <TeamTable />
          </ProtectedRoute>
        }
      />
      <Route
        path="/team/add"
        element={
          <ProtectedRoute>
            <TeamAdd />
          </ProtectedRoute>
        }
      />
      <Route
        path="/team/edit/:id"
        element={
          <ProtectedRoute>
            <TeamUpdate />
          </ProtectedRoute>
        }
      />
      <Route
        path="/testimonial"
        element={
          <ProtectedRoute>
            <TestimonialTable />
          </ProtectedRoute>
        }
      />
      <Route
        path="/testimonial/add"
        element={
          <ProtectedRoute>
            <TestimonialAdd />
          </ProtectedRoute>
        }
      />
      <Route
        path="/testimonial/edit/:id"
        element={
          <ProtectedRoute>
            <TestimonialUpdate />
          </ProtectedRoute>
        }
      />
      <Route
        path="/pages"
        element={
          <ProtectedRoute>
            <PagesTable />
          </ProtectedRoute>
        }
      />
      <Route
        path="/pages/add"
        element={
          <ProtectedRoute>
            <PagesAdd />
          </ProtectedRoute>
        }
      />
      <Route
        path="/pages/edit/:id"
        element={
          <ProtectedRoute>
            <PagesUpdate />
          </ProtectedRoute>
        }
      />
      <Route
        path="/gallery"
        element={
          <ProtectedRoute>
            <GalleryTable />
          </ProtectedRoute>
        }
      />
      <Route
        path="/gallery/add"
        element={
          <ProtectedRoute>
            <GalleryAdd />
          </ProtectedRoute>
        }
      />
      <Route
        path="/gallery/edit/:id"
        element={
          <ProtectedRoute>
            <GalleryUpdate />
          </ProtectedRoute>
        }
      />
      <Route
        path="/slider"
        element={
          <ProtectedRoute>
            <SliderTable />
          </ProtectedRoute>
        }
      />
      <Route
        path="/slider/add"
        element={
          <ProtectedRoute>
            <SliderAdd />
          </ProtectedRoute>
        }
      />
      <Route
        path="/slider/edit/:id"
        element={
          <ProtectedRoute>
            <SliderUpdate />
          </ProtectedRoute>
        }
      />
      <Route
        path="/contacts"
        element={
          <ProtectedRoute>
            <ContactTable />
          </ProtectedRoute>
        }
      />
      <Route
        path="/newsletter"
        element={
          <ProtectedRoute>
            <NewsLetterTable />
          </ProtectedRoute>
        }
      />
      <Route
        path="/career-query"
        element={
          <ProtectedRoute>
            <CareersQueryTable />
          </ProtectedRoute>
        }
      />

      <Route
        path="/blog"
        element={
          <ProtectedRoute>
            <BlogTable />
          </ProtectedRoute>
        }
      />
      <Route
        path="/blog/add"
        element={
          <ProtectedRoute>
            <BlogAdd />
          </ProtectedRoute>
        }
      />
      <Route
        path="/blog/edit/:id"
        element={
          <ProtectedRoute>
            <BlogUpdate />
          </ProtectedRoute>
        }
      />
      <Route
        path="/user"
        element={
          <ProtectedRoute>
            <UserTable />
          </ProtectedRoute>
        }
      />
      <Route
        path="/user/add"
        element={
          <ProtectedRoute>
            <UserAdd />
          </ProtectedRoute>
        }
      />
      <Route
        path="/user/edit/:id"
        element={
          <ProtectedRoute>
            <UserUpdate />
          </ProtectedRoute>
        }
      />
      <Route
        path="/career"
        element={
          <ProtectedRoute>
            <CareerTable />
          </ProtectedRoute>
        }
      />
      <Route
        path="/career/add"
        element={
          <ProtectedRoute>
            <CareerAdd />
          </ProtectedRoute>
        }
      />
      <Route
        path="/career/edit/:id"
        element={
          <ProtectedRoute>
            <CareerUpdate />
          </ProtectedRoute>
        }
      />
      <Route
        path="/lead"
        element={
          <ProtectedRoute>
            <LeadTable />
          </ProtectedRoute>
        }
      />
      <Route
        path="/lead/add"
        element={
          <ProtectedRoute>
            <LeadAdd />
          </ProtectedRoute>
        }
      />
      <Route
        path="/lead/edit/:id"
        element={
          <ProtectedRoute>
            <LeadUpdate />
          </ProtectedRoute>
        }
      />
      <Route
        path="/setting"
        element={
          <ProtectedRoute>
            <Setting />
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile/update"
        element={
          <ProtectedRoute>
            <ProfileUpdate />
          </ProtectedRoute>
        }
      />
      <Route
        path="/db-manage"
        element={
          <ProtectedRoute>
            <DBManager />
          </ProtectedRoute>
        }
      />

      <Route
        path="/master/facility"
        element={
          <ProtectedRoute>
            <FacilityTable />
          </ProtectedRoute>
        }
      />
      <Route
        path="/master/facility/add"
        element={
          <ProtectedRoute>
            <FacilityAdd />
          </ProtectedRoute>
        }
      />
      <Route
        path="/master/facility/edit/:id"
        element={
          <ProtectedRoute>
            <FacilityUpdate />
          </ProtectedRoute>
        }
      />

      <Route
        path="/master/discount-coupon"
        element={
          <ProtectedRoute>
            <DiscountCouponTable />
          </ProtectedRoute>
        }
      />
      <Route
        path="/master/discount-coupon/add"
        element={
          <ProtectedRoute>
            <DiscountCouponForm />
          </ProtectedRoute>
        }
      />
      <Route
        path="/master/discount-coupon/edit/:id"
        element={
          <ProtectedRoute>
            <DiscountCouponForm />
          </ProtectedRoute>
        }
      />

      <Route
        path="/master/subscription-plan"
        element={
          <ProtectedRoute>
            <SubscriptionPlanTable />
          </ProtectedRoute>
        }
      />
      <Route
        path="/master/subscription-plan/add"
        element={
          <ProtectedRoute>
            <SubscriptionPlanForm />
          </ProtectedRoute>
        }
      />
      <Route
        path="/master/subscription-plan/edit/:id"
        element={
          <ProtectedRoute>
            <SubscriptionPlanForm />
          </ProtectedRoute>
        }
      />
      <Route
        path="/vendor"
        element={
          <ProtectedRoute>
            <VendorTable />
          </ProtectedRoute>
        }
      />
      <Route
        path="/vendor/on-boarding/:edit_id?/:type?"
        element={
          <ProtectedRoute>
            <ManageVendor />
          </ProtectedRoute>
        }
      />
      <Route
        path="/vendor/view/:edit_id?"
        element={
          <ProtectedRoute>
            <ViewVendor />
          </ProtectedRoute>
        }
      />
      <Route
        path="/vendor/bills/:vendor_id?"
        element={
          <ProtectedRoute>
            <VendorBills />
          </ProtectedRoute>
        }
      />
      <Route
        path="/my/bills/:vendor_id?"
        element={
          <ProtectedRoute>
            <VendorBills />
          </ProtectedRoute>
        }
      />
      <Route
        path="/vendor/bills/pending-discount"
        element={
          <ProtectedRoute>
            <AdminDiscountDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/vendor/upcoming-billing"
        element={
          <ProtectedRoute>
            <UpcomingBillingDates />
          </ProtectedRoute>
        }
      />
      <Route
        path="/vendor/purge/:edit_id?"
        element={
          <ProtectedRoute>
            <VendorPurge />
          </ProtectedRoute>
        }
      />

      <Route
        path="/log/webhooks"
        element={
          <ProtectedRoute>
            <WebhookLogs />
          </ProtectedRoute>
        }
      />

      <Route
        path="/log/bills"
        element={
          <ProtectedRoute>
            <VendorBillLogs />
          </ProtectedRoute>
        }
      />
      <Route
        path="/log/discount"
        element={
          <ProtectedRoute>
            <DiscountLogs />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

export default RoutesList;
